
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import dayjs from "dayjs";
import { addCurrencyUnit } from "@common/src/utils/tools";

const base = namespace("base");
const purchase = namespace("purchase");
const setting = namespace("setting");

@Component({})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("setting.select-test-item"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class ConfirmPayment extends Vue {
  @purchase.State paymentBtnLoading;
  @base.Action getDictionaryList;
  @purchase.Action getPurchaseList;
  @setting.Action getPatternPaymentList;
  @Prop()
  show: boolean;
  @Prop()
  supplierCode: string;
  @Prop()
  paidAmount: string;
  @Prop()
  purchaseReturnList: any;
  dayjs = dayjs;
  addCurrencyUnit = addCurrencyUnit;
  formData: any = {
    settleType: 1,
    paidMethod: "",
    paidAmount: ""
  };
  get $suppilerCode() {
    return this.supplierCode;
  }
  emptyToLine = emptyToLine;
  payWayList: any = [];
  created() {
    this.init();
    this.formData.paidAmount = this.paidAmount;
  }
  get seletedAmount() {
    return this.mix_selectedRows.reduce((prev, cur) => {
      return prev + Number(cur.purchaseAmount);
    }, 0);
  }
  formDataRules: any = {
    paidMethod: [{ required: true, message: t("v210831.please-select-payment"), trigger: "change" }]
  };
  @Watch("paidAmount")
  watchStatus(val) {
    this.formData.paidAmount = val;
  }
  @Watch("purchaseReturnList")
  watchPurchaseReturnList(val) {
    this.purchaseReturnList = val;
  }
  init() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
  }
  loadListData() {
    return [];
  }
  purchaseOrderList: any = [];
  handleSettleTypeChange(val) {
    if (val === 2) {
      this.getPurchaseList({
        supplierCode: this.$suppilerCode,
        settlementStatus: "0",
        pageNum: 1,
        pageSize: 999
      }).then(data => {
        this.purchaseOrderList = data.data.list;
      });
    }
  }
  handleCancel() {
    this.$emit("update:show", false);
  }
  handleConfirm() {
    if (!this.formData.paidMethod) {
      return this.$message.error(this.$t("v210831.please-select-payment") as string);
    }
    this.$emit(
      "confirmBtnClick",
      Object.assign({}, this.formData, {
        selectedRows: this.mix_selectedRows
      })
    );
  }
}
